import React from 'react'
import IconWrapper from '@/shared/components/UI/IconWrapper'
import TruncatedTooltip from '@/v3-dashboard/components/UI/TruncatedTooltip'

const Link = (
    {
        label = '',
        href = '',
        target = '_blank',
        onClick,
        className = '',
        disabled = false,
        visible = true,
        icon,
        iconSize = 20,
        size = 'md',
        noPadding = false,
        labelClassName = '',
        tooltipContent,
        tooltipPosition = 'top center',
        ...props
    }
) => {
  if (!visible) return null


  const sizeClasses = {
    sm: 'h-[32px]',
    md: 'h-[40px]',
    lg: 'h-[44px]',
  }

  return (
    <a
      // href={disabled ? undefined : href}
      target={target}
      onClick={onClick}
      className={`
        group
        no-underline
        hover:no-underline
        block
        min-w-[105px]
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
      {...props}
    >
      <div className={`flex items-center gap-v3-xs min-w-0 ${noPadding ? '' : 'py-v3-ms px-v3-sm'} font-inter-variable text-v3-h9 text-v3-purple-primary font-medium hover:text-v3-purple-medium transition-colors duration-200 ${sizeClasses[size]}`}>
        {tooltipContent ? (
          <TruncatedTooltip content={tooltipContent} position={tooltipPosition}>
            <p className={`flex-1 min-w-0 truncate ${labelClassName}`}>{label}</p>
          </TruncatedTooltip>
        ) : (
          <p className={`flex-1 min-w-0 truncate ${labelClassName}`}>{label}</p>
        )}
        {icon && (
          <IconWrapper size={iconSize} className="cursor-pointer ">
            {icon}
          </IconWrapper>
        )}
      </div>
    </a>
  )
}

export default Link